import React from 'react'
import { toAbsoluteUrl } from 'src/app/utils/AssetHelper'
function GameHeader({children,...props}) {
    return (
        <>
            <div className="header clearfix">
                <div className="float-left "></div>
                    <div className="right-info float-right text-right">
                        <img src={toAbsoluteUrl('/s_logo.png')} className="img-fluid custom-img"  />
                </div>
            </div>
            {children}
       
        </>
 
    )
}

export default GameHeader

